"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _polished = require("polished");

var _styledSystem = require("styled-system");

var createGradient = function createGradient(_ref, theme, fn) {
  var from = _ref.from,
      to = _ref.to,
      transition = _ref.transition,
      direction = _ref.direction;

  if (fn === void 0) {
    fn = _polished.linearGradient;
  }

  var getColour = function getColour(colour) {
    return (0, _styledSystem.themeGet)("colors." + colour)({
      theme: theme
    });
  };

  return fn({
    colorStops: [getColour(from) + " 0%", getColour(to) + " " + transition],
    toDirection: direction,
    fallback: "transparent"
  });
};

var _default = createGradient;
exports["default"] = _default;